@if (isLoading) {
    <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
}
@else {
    @if(loadingSuccess) {
        <div class="justify-center items-center md:items-start flex flex-col md:flex-row gap-4">
            <div class="w-[24rem] sm:w-[48rem] flex flex-col gap-2">
                <div class="flex flex-row border-b border-ponder-light border-opacity-10 items-center">
                    <div class="grow font-bold p-2">
                        Friends
                    </div>
                    <user-friend-add [username]="username"></user-friend-add>
                </div>
                @if (pending.length || friends.length) {
                    @if (friends.length) {
                        <div class="flex flex-col gap-2">
                            @for (f of friends ; track f) {
                                <user-friend [isOwnFriends]="isOwnFriends" [relationship]="f"></user-friend>
                            }
                        </div>
                    }
                    @if (pending.length) {
                        <div class="flex flex-col gap-2">
                            <div class="border-b border-ponder-light border-opacity-10 font-bold p-2 mt-4">
                                Pending
                            </div>
                            @for (p of pending ; track p) {
                                <user-friend [isOwnFriends]="isOwnFriends" [relationship]="p"></user-friend>
                            }
                        </div>
                    }
                } @else {
                    <div class="flex p-8 bg-slate-100 rounded shadow text-center items-center align-middle justify-center text-sm text-slate-400 italic">
                        <div>You have not yet added any friends</div>
                    </div>
                }
            </div>
        </div>
    } @else {
        <unauthorized [authSession]="authSession"></unauthorized>
    }
}